(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("$DSTypeManager", [], factory);
	else if(typeof exports === 'object')
		exports["$DSTypeManager"] = factory();
	else
		root["$DSTypeManager"] = factory();
})(this, () => {
return 